import { Outlet } from 'react-router-dom';

import { AccessDenied } from './AccessDenied';
import type { AccessGate } from './types/access-gate.type';

interface Props {
  readonly gate: AccessGate | undefined;
  readonly isFresh: boolean;
}

export const PageGate = ({ gate, isFresh }: Readonly<Props>) =>
  gate && isFresh && !gate.isAllowed && gate.reasons.length ? (
    <AccessDenied reasons={gate.reasons} />
  ) : (
    <Outlet />
  );
